import React from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import useDataLoader2 from "../../hooks/useDataLoader2";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import { formatTimeSpanToString } from "../../utils/functions";
import { defaultPageSize } from '../../utils/const';
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { IRegion } from "../../interfaces";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const Region: React.FC = () => {
  const fields = [
    'id', 
    'legacyId',
    'legacyOldId',
    'name',
    'abbreviation',
    'createdDate'
  ]
  const endpoint = "/region";
  const { 
    data, 
    totalCount, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: "Name" },
    { id: 'abbreviation', header: "Abbreviation" },
    { id: 'createdDate', header: "Created Date" },
    {
      id: 'edit', 
      header: 'Edit', 
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: IRegion[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : ''
      }
    })
    return formatedData
  }

  return (
    <>
      <div>
        <CatalogTableC
          title="Region Catalog"
          catalogName={"REGIONS"}
          catalogShortName={"Region"}
          route={"Region"}
          totalCount={totalCount}
        >
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
      </div>
    </>
  );
};

export default Region;
